// Debug-mode storage helpers, split out of `ServerErrorWatcher.tsx` so the
// watcher file is a components-only export surface (Fast Refresh hot-reloads
// cleanly when component files don't also export plain functions).

const STORAGE_KEY = 'bp_debug_mode';

/** Toggle debug mode on/off. Call from Settings UI. */
export function setDebugMode(on: boolean) {
  if (on) {
    localStorage.setItem(STORAGE_KEY, '1');
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
  // Trigger storage event for same-tab watchers.
  window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY, newValue: on ? '1' : null }));
}

export function getDebugModeEnabled(): boolean {
  return localStorage.getItem(STORAGE_KEY) === '1';
}
